import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type React from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { forwardRef, useId } from 'react';
import Hint from '../hint';
import Label from '../label';
export type TextAreaProps = {
  className?: string;
  hasError?: boolean;
  hint?: string;
  label?: string;
  onChangeText?: (nextValue: string) => void;
  size?: 'default' | 'compact';
} & TextareaHTMLAttributes<HTMLTextAreaElement>;
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((t0, ref) => {
  const $ = _c(36);
  let baseID;
  let className;
  let hint;
  let label;
  let onChange;
  let onChangeText;
  let placeholder;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      hasError: t1,
      hint,
      id: baseID,
      label,
      onChange,
      onChangeText,
      placeholder,
      className,
      size: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = baseID;
    $[2] = className;
    $[3] = hint;
    $[4] = label;
    $[5] = onChange;
    $[6] = onChangeText;
    $[7] = placeholder;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
  } else {
    baseID = $[1];
    className = $[2];
    hint = $[3];
    label = $[4];
    onChange = $[5];
    onChangeText = $[6];
    placeholder = $[7];
    props = $[8];
    t1 = $[9];
    t2 = $[10];
  }
  const hasError = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  const internalId = useId();
  const id = baseID || internalId;
  let t3;
  if ($[11] !== onChange || $[12] !== onChangeText) {
    t3 = event => {
      if (onChange) {
        onChange(event);
      }
      if (onChangeText) {
        onChangeText(event.currentTarget.value);
      }
    };
    $[11] = onChange;
    $[12] = onChangeText;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const handleChange = t3;
  let t4;
  if ($[14] !== id || $[15] !== label || $[16] !== size) {
    t4 = label && <Label htmlFor={id} size={size}>{label}</Label>;
    $[14] = id;
    $[15] = label;
    $[16] = size;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== className) {
    t5 = cx("fp-textarea", className);
    $[18] = className;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== handleChange || $[21] !== hasError || $[22] !== id || $[23] !== placeholder || $[24] !== props || $[25] !== ref || $[26] !== size || $[27] !== t5) {
    t6 = <textarea className={t5} data-has-error={hasError} data-size={size} id={id} onChange={handleChange} placeholder={placeholder} ref={ref} {...props} />;
    $[20] = handleChange;
    $[21] = hasError;
    $[22] = id;
    $[23] = placeholder;
    $[24] = props;
    $[25] = ref;
    $[26] = size;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== hasError || $[30] !== hint) {
    t7 = hint && <Hint hasError={hasError}>{hint}</Hint>;
    $[29] = hasError;
    $[30] = hint;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t4 || $[33] !== t6 || $[34] !== t7) {
    t8 = <div>{t4}{t6}{t7}</div>;
    $[32] = t4;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  return t8;
});
export default TextArea;